define("calendar/components/calendar/share-posts", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/utils/constants", "later/utils/constants/segment-events", "later/utils/fetch", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _constants, _segmentEvents, _fetch, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/utils/constants",0,"later/utils/constants/segment-events",0,"later/utils/fetch",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Portal @destinationElement="root-portal">
    <Shared::Modal @close={{@closeModal}} as |modal|>
      <modal.card @portrait={{true}} class="u--p__b__md">
        <modal.card-header>
          <p class="o--modalHeader__title u--text--lg">
            {{t "calendar.share_posts.modal.title" count=@selectedPosts.size}}
          </p>
        </modal.card-header>
  
        <modal.card-body>
          <p class="u--p__b__lg u--text--md">
            {{t "calendar.share_posts.modal.subtitle"}}
          </p>
  
          {{#if @createSharePostLink.last.isSuccessful}}
            <div>
              <h3>{{t "calendar.share_posts.modal.share_link_title"}}</h3>
              <div class="o--btnGroup cSP--btnGroup">
                <Shared::Link @href={{@sharePostUrl}} @text={{@sharePostUrl}} class="o--form__input--lg u--ellipsis" />
                <CopyButton @onSuccess={{perform this.onClickCopy}} @text={{@sharePostUrl}} {{button variant="outline"}}>
                  {{t "shared_phrases.copy_link"}}
                </CopyButton>
              </div>
              <p class="u--text--light u--p__t__sm">
                {{t
                  "calendar.share_posts.modal.share_link_expiry"
                  timestamp=(moment-format @sharePostExpiresTime "MMM D [at] hh:mm A z")
                }}
              </p>
            </div>
  
            <div>
              <h3>{{t "calendar.share_posts.modal.share_email_title"}}</h3>
              <form class="o--btnGroup cSP--btnGroup" onsubmit={{perform this.onClickInvite}}>
                <Input
                  @type="email"
                  @value={{this.email}}
                  aria-label={{t "shared_phrases.enter_email"}}
                  class="o--form__input--lg u--m__r__sm"
                  placeholder={{t "shared_phrases.enter_email"}}
                  required
                />
                <Shared::Ui::Button @text={{t "shared_words.invite"}} @variant="primary" type="submit" />
              </form>
  
              <div class="u--flex__wrap u--p__t__sm">
                {{#each this.recentlyUsedEmails as |email|}}
                  <Shared::Ui::Button
                    @onClick={{set this "email" email}}
                    @text={{email}}
                    @variant="unstyled"
                    class="cSP--emailLabel u--p__xs"
                  />
                {{/each}}
              </div>
            </div>
          {{else}}
            <div class="o--card u--m__b u--text--center">
              <div class="o--loading u--m__tb__lg" style="top:0"></div>
              <p class="u--text--light">
                {{t "calendar.share_posts.modal.loading_message"}}
              </p>
            </div>
          {{/if}}
        </modal.card-body>
      </modal.card>
    </Shared::Modal>
  </Shared::Portal>
  */
  {
    "id": "xRd46OrW",
    "block": "[[[8,[39,0],null,[[\"@destinationElement\"],[\"root-portal\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[39,1],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card\"]],[[24,0,\"u--p__b__md\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title u--text--lg\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"calendar.share_posts.modal.title\"],[[\"count\"],[[30,3,[\"size\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"u--p__b__lg u--text--md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"calendar.share_posts.modal.subtitle\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[30,4,[\"last\",\"isSuccessful\"]],[[[1,\"          \"],[10,0],[12],[1,\"\\n            \"],[10,\"h3\"],[12],[1,[28,[35,2],[\"calendar.share_posts.modal.share_link_title\"],null]],[13],[1,\"\\n            \"],[10,0],[14,0,\"o--btnGroup cSP--btnGroup\"],[12],[1,\"\\n              \"],[8,[39,4],[[24,0,\"o--form__input--lg u--ellipsis\"]],[[\"@href\",\"@text\"],[[30,5],[30,5]]],null],[1,\"\\n              \"],[8,[39,5],[[4,[38,7],null,[[\"variant\"],[\"outline\"]]]],[[\"@onSuccess\",\"@text\"],[[28,[37,6],[[30,0,[\"onClickCopy\"]]],null],[30,5]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,2],[\"shared_phrases.copy_link\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--light u--p__t__sm\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"calendar.share_posts.modal.share_link_expiry\"],[[\"timestamp\"],[[28,[37,8],[[30,6],\"MMM D [at] hh:mm A z\"],null]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[12],[1,\"\\n            \"],[10,\"h3\"],[12],[1,[28,[35,2],[\"calendar.share_posts.modal.share_email_title\"],null]],[13],[1,\"\\n            \"],[10,\"form\"],[14,0,\"o--btnGroup cSP--btnGroup\"],[15,\"onsubmit\",[28,[37,6],[[30,0,[\"onClickInvite\"]]],null]],[12],[1,\"\\n              \"],[8,[39,9],[[16,\"aria-label\",[28,[37,2],[\"shared_phrases.enter_email\"],null]],[24,0,\"o--form__input--lg u--m__r__sm\"],[16,\"placeholder\",[28,[37,2],[\"shared_phrases.enter_email\"],null]],[24,\"required\",\"\"]],[[\"@type\",\"@value\"],[\"email\",[30,0,[\"email\"]]]],null],[1,\"\\n              \"],[8,[39,10],[[24,4,\"submit\"]],[[\"@text\",\"@variant\"],[[28,[37,2],[\"shared_words.invite\"],null],\"primary\"]],null],[1,\"\\n            \"],[13],[1,\"\\n\\n            \"],[10,0],[14,0,\"u--flex__wrap u--p__t__sm\"],[12],[1,\"\\n\"],[42,[28,[37,12],[[28,[37,12],[[30,0,[\"recentlyUsedEmails\"]]],null]],null],null,[[[1,\"                \"],[8,[39,10],[[24,0,\"cSP--emailLabel u--p__xs\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,13],[[30,0],\"email\",[30,7]],null],[30,7],\"unstyled\"]],null],[1,\"\\n\"]],[7]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,0],[14,0,\"o--card u--m__b u--text--center\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--loading u--m__tb__lg\"],[14,5,\"top:0\"],[12],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"calendar.share_posts.modal.loading_message\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[2]]]]],[1,\"\\n\"]],[]]]]]],[\"@closeModal\",\"modal\",\"@selectedPosts\",\"@createSharePostLink\",\"@sharePostUrl\",\"@sharePostExpiresTime\",\"email\"],false,[\"shared/portal\",\"shared/modal\",\"t\",\"if\",\"shared/link\",\"copy-button\",\"perform\",\"button\",\"moment-format\",\"input\",\"shared/ui/button\",\"each\",\"-track-array\",\"set\"]]",
    "moduleName": "calendar/components/calendar/share-posts.hbs",
    "isStrictMode": false
  });
  let CalendarSharePostsComponent = _exports.default = (_class = class CalendarSharePostsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "cache", _descriptor3, this);
      _initializerDefineProperty(this, "errors", _descriptor4, this);
      _initializerDefineProperty(this, "intl", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "savedEmailList", _descriptor7, this);
      _initializerDefineProperty(this, "email", _descriptor8, this);
      _defineProperty(this, "CACHE_KEY", `share-posts-${this.currentGroup.id}`);
      _defineProperty(this, "emailListSize", 10);
      _defineProperty(this, "onClickCopy", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track(_segmentEvents.SegmentEventTypes.ClickedCopyLink, {
            number_of_posts: this.selectedPostsCount
          });
          this.alerts.success(this.intl.t('alerts.calendar.share_posts_link.copy_success.message'));
        }
      }), null, "onClickCopy", null));
      _defineProperty(this, "onClickInvite", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          // TODO: set external review status to PENDING
          event.preventDefault();
          const success = yield this.sendInvite.perform(this.email);
          if (success) {
            this.segment.track(_segmentEvents.SegmentEventTypes.SharedLinkToEmail, {
              number_of_posts: this.selectedPostsCount,
              recipient: this.email
            });
            this.alerts.success(this.intl.t('alerts.calendar.share_posts_link.invite_success.message', {
              email: this.email
            }), {
              title: this.intl.t('alerts.calendar.share_posts_link.invite_success.title')
            });
            if (this.savedEmailList.has(this.email)) {
              // move it up to top of list
              this.savedEmailList.delete(this.email);
            } else if (this.savedEmailList.size >= this.emailListSize) {
              // remove the oldest email
              this.savedEmailList = new _trackedBuiltIns.TrackedSet([...this.savedEmailList].slice(-9));
            }
            this.savedEmailList.add(this.email);
            this.cache.add(this.CACHE_KEY, [...this.savedEmailList], {
              expiry: this.cache.expiry(1, 'day'),
              // saves it for the day, then pulls latest from group
              persist: true
            });
            this.email = '';
          }
        }
      }), null, "onClickInvite", null));
      _defineProperty(this, "sendInvite", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (emailAddress) {
          try {
            yield (0, _fetch.fetch)(`/api/v2/post_review_shares/${this.args.shareId}/add_email`, {
              method: _constants.HttpMethod.Post,
              body: {
                group_id: this.currentGroup.id,
                post_review_share: {
                  email_addresses: emailAddress ? [emailAddress] : undefined
                }
              }
            });
            return true;
          } catch (error) {
            this.alerts.alert(this.intl.t('alerts.calendar.share_posts_link.share_link_creation_failed.message'), {
              title: this.intl.t('alerts.calendar.share_posts_link.share_link_creation_failed.title')
            });
            this.errors.log(`Unable to create invite for email: ${this.email}`, error);
          }
          return false;
        }
      }), null, "sendInvite", null));
      const emails = this.cache.retrieve(this.CACHE_KEY);
      if (emails) {
        this.savedEmailList = new _trackedBuiltIns.TrackedSet(emails);
      } else {
        // pull up to last 10 most recently added from currentGroup emails
        this.savedEmailList = new _trackedBuiltIns.TrackedSet(this.currentGroup.emailAddresses.slice(-this.emailListSize));
      }
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get selectedPostsCount() {
      return this.args.selectedPosts?.size ?? 0;
    }
    get recentlyUsedEmails() {
      return [...this.savedEmailList].reverse();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "savedEmailList", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "email", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CalendarSharePostsComponent);
});